import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import routes from '@routes';
import { Formik, Form } from 'formik';

import { NoContent } from '@components/Albums/style';

import TableView from '@components/Albums/TableView/index';
import BatchActions from '@components/Albums/BatchActions';

const Albums = ({ items, view, updateSelectedAlbums, downloadBatch }) => {
  const history = useHistory();
  const { kind } = useParams();

  const stems = kind === 'stems';

  const moveToAlbum = useCallback(
    uuid => {
      history.push(routes.album(uuid, stems));
    },
    [stems],
  );

  if (items.length) {
    return (
      <Formik
        enableReinitialize
        initialValues={{ albums: [] }}
        onSubmit={({ albums }) => {
          updateSelectedAlbums(albums);
        }}
      >
        {({ submitForm, values, resetForm, isSubmitting }) => (
          <Form>
            {values.albums.length > 0 ? (
              <BatchActions
                albumsSize={values.albums.length}
                reset={resetForm}
                isSubmitting={isSubmitting}
                downloadBatch={downloadBatch}
                stems={stems}
              />
            ) : null}

            <TableView
              moveToAlbum={moveToAlbum}
              selectedAlbums={values.albums}
              submitForm={submitForm}
              stems={stems}
            />
          </Form>
        )}
      </Formik>
    );
  }

  return <NoContent view={view}>No Albums found</NoContent>;
};

Albums.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  view: PropTypes.oneOf(['list', 'grid']).isRequired,
  updateSelectedAlbums: PropTypes.func.isRequired,
  downloadBatch: PropTypes.func.isRequired,
  order: PropTypes.shape({
    by: PropTypes.string,
    dir: PropTypes.oneOf(['asc', 'desc']),
  }).isRequired,
};

export default memo(Albums);
